import { render, staticRenderFns } from "./b44.vue?vue&type=template&id=460c7fe8&scoped=true&"
import script from "./b44.vue?vue&type=script&lang=js&"
export * from "./b44.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460c7fe8",
  null
  
)

export default component.exports